/* Olfatelier : ajout au panier (duo, coffret) et compteur « Composez votre coffret ». */
(() => {
  if (window.olCart) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // Les événements du thème (pubsub.js, constants.js) ne sont pas sur window : on les lit directement.
  const events = () => (typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null);
  const parse = (html, selector) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  };

  // Décant = format de 10 ml ou moins (le flacon entier ne compte pas dans le coffret).
  function isDecant(title) {
    const t = String(title || '').toLowerCase().replace(',', '.');
    if (t.includes('flacon') || t.includes('blister')) return false;
    const m = t.match(/(\d+(?:\.\d+)?)\s*ml/);
    return !!m && parseFloat(m[1]) <= 10;
  }

  // « 5:10 » = -10 % dès 5 décants ; « 3:10,5:15 » = deux paliers.
  function paliers(str) {
    return String(str || '5:10').split(',')
      .map((p) => p.split(':').map(Number))
      .filter((p) => p[0] > 0 && p[1] > 0)
      .sort((a, b) => a[0] - b[0]);
  }

  function decants(cart) {
    const list = [];
    (cart.items || []).forEach((item) => {
      if (!isDecant(item.variant_title)) return;
      for (let i = 0; i < item.quantity; i += 1) list.push(item);
    });
    return list;
  }

  function etat(n, str) {
    const p = paliers(str);
    const max = p.length ? p[p.length - 1][0] : 5;
    const acquis = p.filter((x) => n >= x[0]).pop();
    const suivant = p.find((x) => n < x[0]);
    const s = (k) => (k > 1 ? 's' : '');
    let texte;
    if (!suivant) {
      texte = `Coffret complet : -${acquis[1]} % sur vos décants dans le panier.`;
    } else if (acquis) {
      const k = suivant[0] - n;
      texte = `-${acquis[1]} % déjà acquis. Encore ${k} décant${s(k)} pour -${suivant[1]} %.`;
    } else if (n > 0) {
      const k = suivant[0] - n;
      texte = `${n} décant${s(n)} dans votre panier. Encore ${k} pour -${suivant[1]} %.`;
    } else {
      texte = `Ajoutez ${suivant[0]} décants, la remise de -${suivant[1]} % s'applique toute seule.`;
    }
    return { texte, max, n, complet: !suivant };
  }

  function getCart() {
    return fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
  }

  // Panier du thème : tiroir (cart-drawer) ou fenêtre « Ajouté au panier » (cart-notification).
  function cartUi() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function renderSilently(ui, sections) {
    if (ui.tagName === 'CART-DRAWER') {
      const inner = sections['cart-drawer'] && parse(sections['cart-drawer'], '#CartDrawer');
      const target = document.getElementById('CartDrawer');
      if (inner && target) target.innerHTML = inner.innerHTML;
      ui.classList.remove('is-empty');
    }
    ['cart-icon-bubble', 'cart-notification-button'].forEach((id) => {
      const src = sections[id] && parse(sections[id], '.shopify-section');
      const el = document.getElementById(id);
      if (src && el) el.innerHTML = src.innerHTML;
    });
  }

  function notify(res) {
    if (typeof publish === 'function' && events()) {
      publish(events().cartUpdate, { source: 'ol-cart', cartData: res });
    }
    document.dispatchEvent(new CustomEvent('ol:cart-change'));
  }

  function add(items, options) {
    const open = !options || options.open !== false;
    const ui = cartUi();
    const body = { items };
    if (ui && typeof ui.getSectionsToRender === 'function') {
      body.sections = ui.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    return fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((res) => {
        if (res.status) throw new Error(res.description || res.message || 'Ajout impossible');
        if (ui && res.sections) {
          if (open) {
            if (ui.tagName === 'CART-DRAWER') ui.classList.remove('is-empty');
            // La fenêtre « Ajouté au panier » montre le premier article ajouté.
            if (!res.key && res.items && res.items.length) res.key = res.items[0].key;
            ui.renderContents(res);
          } else {
            renderSilently(ui, res.sections);
          }
        } else if (open) {
          window.location.href = `${root}cart`;
        }
        notify(res);
        return res;
      });
  }

  function openCart() {
    const ui = document.querySelector('cart-drawer');
    if (ui && typeof ui.open === 'function') ui.open();
    else window.location.href = `${root}cart`;
  }

  // Met à jour tous les blocs [data-ol-coffret] de la page.
  function refresh() {
    const blocks = document.querySelectorAll('[data-ol-coffret]');
    if (!blocks.length) return Promise.resolve();
    return getCart().then((cart) => {
      const liste = decants(cart);
      blocks.forEach((block) => {
        const e = etat(liste.length, block.dataset.paliers);
        block.classList.toggle('is-complet', e.complet);
        block.querySelectorAll('[data-ol-etat]').forEach((el) => { el.textContent = e.texte; });
        block.querySelectorAll('[data-ol-pas]').forEach((el, i) => { el.classList.toggle('is-on', i < e.n); });
        block.querySelectorAll('[data-ol-slots]').forEach((wrap) => {
          const slots = wrap.querySelectorAll('[data-ol-slot]');
          slots.forEach((slot, i) => {
            const item = liste[i];
            slot.classList.toggle('is-on', !!item);
            slot.innerHTML = item && item.image
              ? `<img src="${item.image}${item.image.includes('?') ? '&' : '?'}width=96" alt="" width="40" height="40">`
              : '';
          });
          const plus = wrap.querySelector('[data-ol-plus]');
          if (plus) {
            const extra = liste.length - slots.length;
            plus.textContent = extra > 0 ? `+${extra}` : '';
            plus.hidden = extra <= 0;
          }
        });
      });
    }).catch(() => {});
  }

  window.olCart = { add, openCart, refresh, isDecant, etat };

  const start = () => {
    refresh();
    if (typeof subscribe === 'function' && events()) {
      subscribe(events().cartUpdate, () => { setTimeout(refresh, 150); });
    } else {
      document.addEventListener('ol:cart-change', refresh);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();